import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Base/Home'
import Main from '@/components/Dashboard/Main'

// import AlertSettings from '@/components/Alert/AlertSettings'
// import AlertHistory from '@/components/Alert/AlertHistory'
// import Users from '@/components/User/Users'
import Signin from '@/components/Auth/Signin'
import Signup from '@/components/Auth/Signup'
// import Profile from '@/components/Auth/Profile'
import authGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: authGuard,
      children: [
        {
          path: '',
          component: Main
        }
      ]
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    },
    {
      // path: '/signup',
      path: '/signupkeepitprivate',
      name: 'Signup',
      component: Signup
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js